import axios from "axios";
import { apiUrl } from "../../App";

export async function getUserUseCase(type: "phone" | "email" | "username" | "userId", value: string) {
  return await axios.get(`${apiUrl}/admin/users/search`, {
    params: { type, value }, // ✅ send type & value as query params
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
}
